import { useUserEventsByTypesStream } from '@/api';
import { BloodPressureIcon } from '@/Components/Common/Icons';
import { useDashboardModal } from '@/Components/Dashboard/DashboardModal';
import { unitTitleData } from '@/Components/Wellness/WellnessUtils';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { Card } from 'antd';
import { find, get } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import '../RecentActivity.less';
import {
  formatTime,
  getDateLabel,
  getRecentActivityDayWindow,
  HistoryModalTable,
  LoadingCard,
} from '../RecentActivityUtils';

const renderCells = (entry) => (
  <div className="row-cell bp-cell">
    {`${get(entry, 'systolic', '-')}/${get(entry, 'diastolic', '-')} mmHg`}
  </div>
);

const ModalContent = ({ useruuid, eventType, ...displayProps }) => {
  const trans = useSelector(translator);
  const history = useUserEventsByTypesStream({
    useruuid,
    eventTypes: eventType,
    ...getRecentActivityDayWindow(),
  });

  return (
    <HistoryModalTable
      {...displayProps}
      {...history}
      headers={[trans('DATE_L'), trans('BLOODPRESSURE')]}
      renderCells={renderCells}
    />
  );
};

ModalContent.propTypes = {
  useruuid: PropTypes.string,
  eventType: PropTypes.string,
};

export const BiometricBloodPressureCard = (props) => {
  const {
    useruuid,
    data,
    isLoading,
    timezone,
    is24HourFormat,
    locale,
    measurementSystem,
    // trendData,
  } = props;
  const trans = useSelector(translator);
  const { openDashboardModal } = useDashboardModal();

  const openHistoryModal = () =>
    openDashboardModal({
      title: (
        <div className="recent-activity-modal-title">
          <BloodPressureIcon
            className="recent-activity-modal-title-icon"
            hideEclipse={true}
            viewBox="15 15 30 30"
            fill="#005D98"
          />
          <span>{trans('BLOODPRESSURE')}</span>
        </div>
      ),
      content: (
        <ModalContent
          useruuid={useruuid}
          eventType={get(data, 'eventName')}
          timezone={timezone}
          is24HourFormat={is24HourFormat}
          locale={locale}
        />
      ),
    });

  const handleCardClick = (e) => {
    e.preventDefault();
    openHistoryModal();
  };

  const handleCardKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openHistoryModal();
    }
  };

  if (isLoading) return <LoadingCard />;

  const timestamp = get(data, 'utc_timestamp_inms', '');
  const dateLabel = getDateLabel(timestamp, trans, timezone, locale);
  const formattedTime = formatTime(timestamp, is24HourFormat, timezone);
  const dataArray = get(data, 'data', []);
  const systolicDataKey = get(unitTitleData, [measurementSystem, 'systolic'], '');
  const diastolicDataKey = get(unitTitleData, [measurementSystem, 'diastolic'], '');
  const systolic = get(find(dataArray, ['display_label', systolicDataKey]), 'display_value', '');
  const diastolic = get(find(dataArray, ['display_label', diastolicDataKey]), 'display_value', '');
  const bloodPressureLabel = `${systolic}/${diastolic} mmHg`;

  // const trendPercent = get(trendData, 'trendPercent', null);
  // const isUp = trendPercent > 0;
  // const isDown = trendPercent < 0;
  // const displayPercent = trendPercent !== null ? Math.abs(trendPercent) : null;

  const CardTitle = (
    <div className="recent-activity-card-header">
      <BloodPressureIcon
        className="recent-activity-card-icon"
        hideEclipse={true}
        viewBox="15 15 30 30"
        fill="#005D98"
      />
      <h4 className="recent-activity-card-title">{trans('BLOODPRESSURE')}</h4>
    </div>
  );

  return (
    <Card
      className="recent-activity-card"
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
      hoverable
      variant="borderless"
      title={CardTitle}
    >
      <div className="recent-activity-card-body">
        <p className="recent-activity-time">
          {dateLabel} {formattedTime}
        </p>
        <p className="recent-activity-data-value">{bloodPressureLabel}</p>
      </div>
      {/* <>
        <hr className="recent-activity-divider" />
        <div className="recent-activity-footer-section">
          <p className="recent-activity-footer-label">{trans('READINGS_TAKEN')}</p>
          <div className="recent-activity-card-footer">
            <span className="recent-activity-comparison">
              {trans('YESTERDAY_VS_LAST_WEEK_AVG')}
            </span>
            {displayPercent !== null ? (
              <span
                className={`recent-activity-trend ${isUp ? 'up' : isDown ? 'down' : 'neutral'}`}
              >
                {isUp ? (
                  <UpArrowIcon className="trend-arrow" />
                ) : isDown ? (
                  <DownArrowIcon className="trend-arrow" />
                ) : (
                  <RightArrowIcon className="trend-arrow" />
                )}
                <span>{displayPercent}%</span>
              </span>
            ) : (
              <span className="recent-activity-trend neutral">-</span>
            )}
          </div>
        </div>
      </> */}
    </Card>
  );
};

BiometricBloodPressureCard.propTypes = {
  useruuid: PropTypes.string,
  timezone: PropTypes.string,
  is24HourFormat: PropTypes.bool,
  locale: PropTypes.string,
  measurementSystem: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  isLoading: PropTypes.bool,
  trendData: PropTypes.object,
};
